import(/* webpackMode: "eager" */ "/var/www/nextjs-green/src/app/error.tsx");
